import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Born To Run Together",
    copy: "Fitygrity is a running and fitness community first. From your first 5K to your biggest race dream, you never train alone — group runs, virtual challenges and a tribe that shows up for every start line and every finish-line hug.",
    align: "lg:mr-auto lg:pr-24",
  },
  {
    num: "02",
    title: "Travel Is The Reward",
    copy: "We turn races into journeys. Bib, hotel, transfers and a crew of fellow runners — curated trips to quality races across India and abroad, so all you do is run.",
    align: "lg:ml-auto lg:pl-24",
  },
  {
    num: "03",
    title: "Every Mile Counts",
    copy: "No honour systems, no screenshots. Fitygrity's virtual events sync straight from your Strava device — GPS-checked, pace-audited and leaderboard-verified — so every kilometre you earn is real.",
    align: "lg:mx-auto lg:text-center",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
  transition: { duration: 0.8, ease: "easeOut" },
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="px-6 sm:px-12 lg:px-20 py-24 sm:py-32 lg:py-40">
      <motion.p {...fadeUp} className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4E00] mb-6">
        About Fitygrity
      </motion.p>
      <motion.p
        {...fadeUp}
        className="font-serif text-2xl sm:text-3xl lg:text-4xl text-[#0D1117] tracking-tight leading-snug max-w-4xl mb-16 sm:mb-24"
      >
        Building the future of endurance through expeditions, virtual challenges and
        <span className="italic text-[#FF4E00]"> unforgettable athletic gatherings.</span>
      </motion.p>
      <div className="space-y-24 sm:space-y-32 lg:space-y-40">
        {CHAPTERS.map((c) => (
          <motion.div
            key={c.num}
            {...fadeUp}
            className={`max-w-3xl flex flex-col sm:flex-row gap-6 sm:gap-12 ${c.align}`}
          >
            <span className="font-serif text-6xl sm:text-7xl lg:text-8xl font-light text-stroke-amber leading-none shrink-0 select-none">
              {c.num}
            </span>
            <div>
              <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-[#0D1117] tracking-tight mb-5">
                {c.title}
              </h2>
              <p className="text-sm sm:text-base text-[#374151] leading-relaxed max-w-xl">
                {c.copy}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
